export default __webpack_public_path__ + "alberta-encrypted.66df6b193916d5aa7070.svg";